import { useInactivityLogout } from "../../hooks/useInactivityLogout";

const InactivityWatcher = () => {
  useInactivityLogout();
  return null;
};

export default InactivityWatcher;
